import { useEffect,useState } from "react";
import { DataTable } from "../components/DataTable";
import { couponService } from "../services/CouponService";


type Coupon = {
  id: string;
  code: string;
  discount: number;
  type: "Flat" | "Percent";
  minOrder: number;
  maxUses: number;
  usedCount: number;
  expiryDate: string;
  status: "Active" | "Expired";
};

const initialCoupons: Coupon[] = [
  { id: "cp1", code: "WELCOME10", discount: 10,  type: "Percent", minOrder: 500,  maxUses: 500,  usedCount: 124, expiryDate: "2025-12-31", status: "Active"  },
  { id: "cp2", code: "FLAT200",   discount: 200, type: "Flat",    minOrder: 1500, maxUses: 200,  usedCount: 58,  expiryDate: "2025-11-30", status: "Active"  },
  { id: "cp3", code: "DIWALI25",  discount: 25,  type: "Percent", minOrder: 2000, maxUses: 1000, usedCount: 310, expiryDate: "2024-10-15", status: "Expired" },
  { id: "cp4", code: "BRIDE500",  discount: 500, type: "Flat",    minOrder: 5000, maxUses: 100,  usedCount: 22,  expiryDate: "2025-06-30", status: "Active"  },
];

const STYLES = `
  /* ── Create Coupon Card ── */
  .cp-card { background:#fff; border-radius:16px; border:1px solid #f0ebe4; box-shadow:0 2px 12px rgba(26,18,8,.07); overflow:hidden; margin-bottom:4px; }
  .cp-card-head { display:flex; align-items:center; justify-content:space-between; padding:16px 22px; border-bottom:1.5px solid #f5f0eb; background:linear-gradient(135deg,#1a1208 0%,#2d1e0f 100%); }
  .cp-card-title { font-size:15px; font-weight:800; color:#fff; letter-spacing:-.2px; display:flex; align-items:center; gap:8px; }
  .cp-card-title-badge { background:rgba(255,255,255,.12); color:#f5c89a; padding:2px 10px; border-radius:20px; font-size:12px; font-weight:700; border:1px solid rgba(255,255,255,.15); }
  .cp-gen-strip { display:flex; align-items:center; gap:10px; background:rgba(255,255,255,.06); border-top:1px solid rgba(255,255,255,.08); padding:10px 22px; flex-wrap:wrap; }
  .cp-gen-strip-label { color:rgba(255,255,255,.5); font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:.6px; white-space:nowrap; }
  .cp-gen-inp { padding:7px 11px; border:1.5px solid rgba(255,255,255,.12); border-radius:8px; background:rgba(255,255,255,.07); color:#fff; font-size:13px; outline:none; font-family:inherit; width:110px; }
  .cp-gen-inp:focus { border-color:rgba(184,64,14,.7); background:rgba(255,255,255,.1); }
  .cp-gen-inp::placeholder { color:rgba(255,255,255,.25); }
  .cp-gen-btn { padding:7px 15px; border:none; border-radius:8px; background:linear-gradient(135deg,#d4551a,var(--theme)); color:#fff; font-size:12px; font-weight:700; cursor:pointer; font-family:inherit; white-space:nowrap; }
  .cp-gen-btn:hover { filter:brightness(1.1); }
  .cp-card-body { padding:20px 22px; }
  .cp-form-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(160px,1fr)); gap:14px; align-items:end; }
  .cp-field { display:flex; flex-direction:column; gap:5px; }
  .cp-label { font-size:11px; font-weight:700; color:#7a6652; text-transform:uppercase; letter-spacing:.6px; }
  .cp-input { padding:9px 12px; border:1.5px solid #ede6df; border-radius:10px; font-size:13.5px; outline:none; background:#fdf8f3; color:#1a1208; font-family:inherit; transition:border .2s,box-shadow .2s; width:100%; box-sizing:border-box; }
  .cp-input:focus { border-color:var(--theme); box-shadow:0 0 0 3px var(--theme-glow); background:#fff; }
  .cp-type-tabs { display:flex; gap:5px; }
  .cp-type-tab { flex:1; padding:8px 6px; border:1.5px solid #ede6df; border-radius:9px; background:#fdf8f3; font-size:12px; font-weight:700; color:#7a6652; cursor:pointer; text-align:center; transition:all .15s; font-family:inherit; white-space:nowrap; }
  .cp-type-tab.active { border-color:var(--theme); background:var(--theme-light); color:var(--theme); }
  .cp-submit-btn { padding:10px 22px; border:none; border-radius:10px; background:linear-gradient(135deg,#d4551a,var(--theme)); color:#fff; font-size:13.5px; font-weight:700; cursor:pointer; font-family:inherit; box-shadow:0 4px 12px var(--theme-glow); display:flex; align-items:center; gap:7px; white-space:nowrap; height:fit-content; align-self:end; }
  .cp-submit-btn:hover { filter:brightness(1.08); transform:translateY(-1px); }
  .cp-code-display { font-family:monospace; font-size:15px; font-weight:800; letter-spacing:1px; color:var(--theme); }

  /* ── Edit Modal ── */
  .cp-overlay { position:fixed; inset:0; background:rgba(26,18,8,.52); backdrop-filter:blur(4px); z-index:1000; display:flex; align-items:flex-start; justify-content:center; padding:28px 16px; overflow-y:auto; animation:cpFadeIn .2s ease; }
  @keyframes cpFadeIn { from{opacity:0} to{opacity:1} }
  .cp-modal { background:#fff; border-radius:20px; width:100%; max-width:560px; margin:auto; box-shadow:0 24px 64px rgba(26,18,8,.22); animation:cpSlideIn .25s cubic-bezier(.34,1.56,.64,1); overflow:hidden; }
  @keyframes cpSlideIn { from{opacity:0;transform:translateY(24px) scale(.97)} to{opacity:1;transform:none} }
  .cp-modal-head { display:flex; justify-content:space-between; align-items:center; padding:20px 24px; border-bottom:1.5px solid #f0ebe4; }
  .cp-modal-title { font-size:16px; font-weight:800; color:#1a1208; }
  .cp-modal-close { width:34px; height:34px; border-radius:9px; border:1.5px solid #ede6df; background:#fdf8f3; cursor:pointer; font-size:16px; color:#7a6652; display:flex; align-items:center; justify-content:center; }
  .cp-modal-body { padding:22px 24px; display:grid; grid-template-columns:1fr 1fr; gap:14px; }
  .cp-modal-body .cp-full { grid-column:1/-1; }
  .cp-modal-foot { padding:14px 24px; border-top:1.5px solid #f0ebe4; display:flex; justify-content:flex-end; gap:10px; background:#fdf8f3; }
  .cp-btn-cancel { padding:9px 16px; border-radius:10px; border:1.5px solid #ede6df; background:#fff; font-size:13px; font-weight:600; color:#7a6652; cursor:pointer; font-family:inherit; }
  .cp-btn-save { padding:9px 20px; border-radius:10px; border:none; background:linear-gradient(135deg,#d4551a,var(--theme)); color:#fff; font-size:13px; font-weight:700; cursor:pointer; font-family:inherit; }

  /* ── Progress bar ── */
  .cp-prog-wrap { background:#f0ebe4; border-radius:4px; height:5px; flex:1; min-width:60px; overflow:hidden; }
  .cp-prog-bar { height:100%; border-radius:4px; background:linear-gradient(90deg,var(--theme),#e05a28); }
`;

function genCode(prefix: string, len: number) {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  let c = prefix.toUpperCase();
  const need = Math.max(len - c.length, 4);
  for (let i = 0; i < need; i++) c += chars[Math.floor(Math.random() * chars.length)];
  return c;
}

const emptyForm = () => ({ code: "", discount: "", type: "Percent" as "Flat"|"Percent", minOrder: "", maxUses: "", expiryDate: "", status: "Active" as "Active"|"Expired" });

export function CouponsPage() {

  
  const [coupons, setCoupons] = useState<Coupon[]>([]);
  
  // ── inline create form state ──
  const [code,      setCode]      = useState("");
  const [discount,  setDiscount]  = useState("");
  const [type,      setType]      = useState<"Flat"|"Percent">("Percent");
  const [minOrder,  setMinOrder]  = useState("");
  const [maxUses, setMaxUses] =  useState("");
  const [expiryDate,setExpiryDate]= useState("");
  const [genPrefix, setGenPrefix] = useState("");
  const [genLen,    setGenLen]    = useState("8");

  // ── edit modal state ──
  const [editId,    setEditId]    = useState<string|null>(null);
  const [editForm,  setEditForm]  = useState(emptyForm());
const [infoModal, setInfoModal] = useState<{
  msg: string;
  type: "success" | "error" | "warn";
} | null>(null);


  // ── inline add ──
  // function addCoupon() {
  //   if (!code || !discount || !minOrder) return;
  //   setCoupons(p => [{
  //     id: `cp${Date.now()}`,
  //     code: code.toUpperCase(),
  //     discount: Number(discount),
  //     type,
  //     minOrder: Number(minOrder),
  //     maxUses:  Number(maxUses) || 9999,
  //     usedCount: 0,
  //     expiryDate: expiryDate || "No Expiry",
  //     status: "Active",
  //   }, ...p]);
  //   setCode(""); setDiscount(""); setMinOrder(""); setMaxUses(""); setExpiryDate("");
  // }

  // ====================================
// GET ALL COUPONS
// ====================================

useEffect(() => {

  fetchCoupons();

}, []);
function formatDate(date: string | Date) {
  if (!date) return "";

  const d = new Date(date);
  if (isNaN(d.getTime())) return "";

  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

async function fetchCoupons() {

  try {

    const response =
      await couponService.getActiveAll();

    console.log(
      "Coupons API Data",
      response
    );

    const formattedData =
      response.map((item: any) => ({

        id:
          item.couponID.toString(),

        code:
          item.couponCode,

        discount:
          item.discountValue,

        type:
          item.discountType,

        minOrder:
          item.minOrderAmount,

        maxUses:
          item.maxUses,

        usedCount:
          item.usedCount,

      expiryDate: formatDate(item.expiryDate),

        status:
          item.status
      }));

    setCoupons(
      formattedData
    );
  }
  catch (error) {

    console.error(
      "Fetch Coupon Error",
      error
    );
  }
}
async function addCoupon() {

  // =========================
  // VALIDATION
  // =========================

  if (
    !code ||
    !discount ||
    !minOrder
  ) {

    setInfoModal({
      msg: "Please fill all required fields",
      type: "warn"
    });

    return;
  }

  try {

    const payload = {

      couponCode: code.toUpperCase(),

      discountValue: Number(discount),

      discountType: type,

      minOrderAmount: Number(minOrder),

      maxUses: Number(maxUses),

      usedCount: 0,

      expiryDate: expiryDate,

      status: "Active",

      isActive: true,

      // SEO
      metaTitle: "",
      metaDescription: "",
      metaKeywords: "",
      canonicalUrl: "",
      ogTitle: "",
      ogDescription: "",
      ogImage: "",
      schemaMarkup: ""
    };

    const response =
      await couponService.create(
        payload
      );

    console.log(
      "Coupon Created",
      response
    );

    // ====================================
    // ADD IN UI
    // ====================================

    setCoupons(prev => [
      {
        id:
          response.data.couponID,

        code:
          response.data.couponCode,

        discount:
          response.data.discountValue,

        type:
          response.data.discountType,

        minOrder:
          response.data.minOrderAmount,

        maxUses:
          response.data.maxUses,

        usedCount:
          response.data.usedCount,

        expiryDate: formatDate(response.data.expiryDate),

        status:
          response.data.status
      },
      ...prev
    ]);

    // ====================================
    // SUCCESS MODAL
    // ====================================

    setInfoModal({
      msg: "Coupon created successfully",
      type: "success"
    });

    // ====================================
    // CLEAR FORM
    // ====================================

    setCode("");

    setDiscount("");

    setMinOrder("");

    setMaxUses("");

    setExpiryDate("");

  }
  catch (error: any) {

    console.error(
      "Create Coupon Error",
      error
    );

    setInfoModal({
      msg:
        error.message ||
        "Failed to create coupon",
      type: "error"
    });
  }
}
async function updateCoupon() {

  if (!editId) return;

  try {

    const payload = {
      couponID: Number(editId),

      couponCode: editForm.code.toUpperCase(),

      discountValue: Number(editForm.discount),

      discountType: editForm.type,

      minOrderAmount: Number(editForm.minOrder),

      maxUses: Number(editForm.maxUses) || 9999,

      expiryDate: editForm.expiryDate,

      status: editForm.status,

      isActive: editForm.status === "Active",

      metaTitle: "",
      metaDescription: "",
      metaKeywords: "",
      canonicalUrl: "",
      ogTitle: "",
      ogDescription: "",
      ogImage: "",
      schemaMarkup: ""
    };

    await couponService.update(payload);

    await fetchCoupons();

    setInfoModal({
      msg: "Coupon updated successfully",
      type: "success"
    });

    setEditId(null);

  }
  catch (error: any) {

    console.error(
      "Update error:",
      error
    );

    setInfoModal({
      msg:
        error?.message ||
        "Failed to update coupon",
      type: "error"
    });
  }
}
  // ── edit modal ──
  function openEdit(c: Coupon) {

  let formattedDate = "";

  if (
    c.expiryDate &&
    c.expiryDate !== "No Expiry"
  ) {

    const date =
      new Date(c.expiryDate);

    if (!isNaN(date.getTime())) {

      formattedDate =
        date.toISOString().split("T")[0];
    }
  }

  setEditForm({
    code: c.code,

    discount:
      String(c.discount),

    type:
      c.type,

    minOrder:
      String(c.minOrder),

    maxUses:
      String(c.maxUses),

    expiryDate:
      formattedDate,

    status:
      c.status
  });

  setEditId(c.id);
}
  function ef<K extends keyof typeof editForm>(k: K, v: typeof editForm[K]) { setEditForm(p => ({ ...p, [k]: v })); }
  function saveEdit() {
    if (!editId || !editForm.code || !editForm.discount) return;
    setCoupons(p => p.map(c => c.id === editId ? { ...c, code: editForm.code.toUpperCase(), discount: Number(editForm.discount), type: editForm.type, minOrder: Number(editForm.minOrder), maxUses: Number(editForm.maxUses) || 9999, expiryDate: editForm.expiryDate || "No Expiry", status: editForm.status } : c));
    setEditId(null);
  }

async function deleteCoupon(id: string) {

  try {

    await couponService.delete(
      Number(id)
    );

    // remove from UI immediately
    setCoupons(prev =>
      prev.filter(
        c => c.id !== id
      )
    );

    setInfoModal({
      msg: "Coupon deleted successfully",
      type: "success"
    });

  }
  catch (error: any) {

    console.error(
      "Delete Coupon Error",
      error
    );

    setInfoModal({
      msg:
        error?.message ||
        "Failed to delete coupon",
      type: "error"
    });
  }
}
async function toggleCoupon(
  id: string
) {

  try {

    const coupon =
      coupons.find(
        c => c.id === id
      );

    if (!coupon) return;

    const newStatus =
      coupon.status === "Active"
        ? "Expired"
        : "Active";

    const payload = {

      couponID:
        Number(coupon.id),

      couponCode:
        coupon.code,

      discountValue:
        coupon.discount,

      discountType:
        coupon.type,

      minOrderAmount:
        coupon.minOrder,

      maxUses:
        coupon.maxUses,

      usedCount:
        coupon.usedCount,

      expiryDate: formatDate(coupon.expiryDate),

      status:
        newStatus,

      isActive: true,


      metaTitle: "",
      metaDescription: "",
      metaKeywords: "",
      canonicalUrl: "",
      ogTitle: "",
      ogDescription: "",
      ogImage: "",
      schemaMarkup: ""
    };

    await couponService.update(
      payload
    );

    setCoupons(prev =>
      prev.map(c =>
        c.id === id
          ? {
              ...c,
              status: newStatus
            }
          : c
      )
    );

    setInfoModal({
      msg:
        `Coupon ${newStatus}`,
      type: "success"
    });

  }
  catch (error: any) {

    console.error(
      "Toggle Error",
      error
    );

    setInfoModal({
      msg:
        "Failed to update coupon status",
      type: "error"
    });
  }
}

  return (
    <>
      <style>{STYLES}</style>
      <div className="d-grid gap-3">

        {/* ── Inline Create Coupon Card ── */}
      
          <div className="cp-card">
            {/* Card header */}
            <div className="cp-card-head">
              <div className="cp-card-title">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>
                Create Coupon
                <span className="cp-card-title-badge">Admin Only</span>
              </div>
            </div>

            {/* Auto-generate strip */}
            <div className="cp-gen-strip">
              <span className="cp-gen-strip-label">🎲 Auto Generate</span>
              <input className="cp-gen-inp" placeholder="Prefix e.g. SAVE" value={genPrefix} onChange={e => setGenPrefix(e.target.value)} />
              <input className="cp-gen-inp" type="number" placeholder="Length" min={4} max={16} value={genLen} onChange={e => setGenLen(e.target.value)} style={{ width: 80 }} />
              <button className="cp-gen-btn" type="button" onClick={() => setCode(genCode(genPrefix, Number(genLen) || 8))}>
                ✨ Generate Code
              </button>
              {code && <span className="cp-code-display">{code}</span>}
            </div>

            {/* Form fields */}
            <div className="cp-card-body">
              <div className="cp-form-grid">
                {/* Coupon Code */}
                <div className="cp-field">
                  <label className="cp-label">Coupon Code *</label>
                  <input className="cp-input cp-code-display" placeholder="e.g. SAVE50" value={code} onChange={e => setCode(e.target.value.toUpperCase())} />
                </div>

                {/* Discount Type */}
                <div className="cp-field">
                  <label className="cp-label">Discount Type</label>
                  <div className="cp-type-tabs">
                    <button type="button" className={`cp-type-tab ${type === "Percent" ? "active" : ""}`} onClick={() => setType("Percent")}>% Percent</button>
                    <button type="button" className={`cp-type-tab ${type === "Flat" ? "active" : ""}`} onClick={() => setType("Flat")}>₹ Flat</button>
                  </div>
                </div>

                {/* Discount value */}
                <div className="cp-field">
                  <label className="cp-label">{type === "Percent" ? "Discount %" : "Discount ₹"} *</label>
                  <input className="cp-input" type="number" placeholder={type === "Percent" ? "e.g. 10" : "e.g. 200"} value={discount} onChange={e => setDiscount(e.target.value)} />
                </div>

                {/* Min order */}
                <div className="cp-field">
                  <label className="cp-label">Min Order (₹) *</label>
                  <input className="cp-input" type="number" placeholder="e.g. 999" value={minOrder} onChange={e => setMinOrder(e.target.value)} />
                </div>

                {/* Max uses */}
                <div className="cp-field">
                  <label className="cp-label">Max Uses</label>
                  <input className="cp-input" type="number" placeholder="Unlimited" value={maxUses} onChange={e => setMaxUses(e.target.value)} />
                </div>

                {/* Expiry date */}
                <div className="cp-field">
                  <label className="cp-label">Expiry Date</label>
                  <input className="cp-input" type="date" value={expiryDate} onChange={e => setExpiryDate(e.target.value)} />
                </div>

                {/* Submit */}
                <button type="button" className="cp-submit-btn" onClick={addCoupon}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                  Add Coupon
                </button>
              </div>
            </div>
          </div>
      

        {/* ── Data Table ── */}
        <DataTable
  title="Coupons"
  rows={coupons as unknown as Record<string, unknown>[]}
  columns={[
    {
      key: "code",
      label: "Code",
      render: (row) => (
        <code
          style={{
            fontWeight: 800,
            color: "var(--theme)",
            background: "var(--theme-light)",
            padding: "2px 9px",
            borderRadius: 6,
            fontSize: 13,
          }}
        >
          {String(row.code)}
        </code>
      ),
    },

    {
      key: "discount",
      label: "Discount",
      render: (row) =>
        row.type === "Percent" ? (
          <span style={{ color: "#059669", fontWeight: 700 }}>
            {String(row.discount)}% OFF
          </span>
        ) : (
          <span style={{ color: "#059669", fontWeight: 700 }}>
            ₹{String(row.discount)} OFF
          </span>
        ),
    },

    {
      key: "minOrder",
      label: "Min Order",
      render: (row) =>
        `₹${Number(row.minOrder).toLocaleString()}`,
    },

   {
  key: "usage",
  label: "Usage",

  render: (row) => {

    // FIX NaN ISSUE
    const used =
      Number(row.usedCount) || 0;

    const max =
      Number(row.maxUses) || 0;

    const pct =
      max > 0
        ? Math.min(
            100,
            Math.round((used / max) * 100)
          )
        : 0;

    return (

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          minWidth: 110,
        }}
      >

        <small
          style={{
            whiteSpace: "nowrap",
            color: "#7a6652",
          }}
        >
          {used}/{max === 9999 ? "∞" : max}
        </small>

        <div className="cp-prog-wrap">

          <div
            className="cp-prog-bar"
            style={{
              width: `${pct}%`
            }}
          />

        </div>

      </div>
    );
  },
},

    {
      key: "expiryDate",
      label: "Expiry",
      render: (row) => (
        <small style={{ color: "#7a6652" }}>
          {String(row.expiryDate)}
        </small>
      ),
    },

    {
      key: "status",
      label: "Status",
      render: (row) => (
        <span
          className={`badge ${
            row.status === "Active"
              ? "text-bg-success"
              : "text-bg-danger"
          }`}
        >
          {String(row.status)}
        </span>
      ),
    },

    {
      key: "actions",
      label: "Actions",
      className: "text-end",

      render: (row) => (
        <div className="d-flex gap-2 justify-content-end">
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={() =>
              openEdit(row as unknown as Coupon)
            }
          >
            Edit
          </button>

          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={() =>
              toggleCoupon(row.id as string)
            }
          >
            {row.status === "Active"
              ? "Expire"
              : "Activate"}
          </button>

          <button
            type="button"
            className="btn btn-sm btn-outline-danger"
            onClick={() =>
              deleteCoupon(row.id as string)
            }
          >
            Delete
          </button>
        </div>
      ),
    },
  ]}
  rowKey={(row) => String(row.id)}
  searchPlaceholder="Search coupons..."
  exportFileName="coupons"
  onDeleteRow={(id) => deleteCoupon(id as string)}
  deleteItemLabel="Coupon"
/>
      </div>

      {/* ── Edit Modal ── */}
      {editId && (
        <div className="cp-overlay" onClick={e => { if (e.target === e.currentTarget) setEditId(null); }}>
          <div className="cp-modal">
            <div className="cp-modal-head">
              <span className="cp-modal-title">Edit Coupon</span>
              <button className="cp-modal-close" onClick={() => setEditId(null)} type="button">✕</button>
            </div>
            <div className="cp-modal-body">
              <div className="cp-field cp-full">
                <label className="cp-label">Coupon Code *</label>
                <input className="cp-input" style={{ fontFamily: "monospace", fontWeight: 800, fontSize: 15 }} value={editForm.code} onChange={e => ef("code", e.target.value.toUpperCase())} />
              </div>
              <div className="cp-field cp-full">
                <label className="cp-label">Discount Type</label>
                <div className="cp-type-tabs">
                  <button type="button" className={`cp-type-tab ${editForm.type === "Percent" ? "active" : ""}`} onClick={() => ef("type", "Percent")}>% Percent</button>
                  <button type="button" className={`cp-type-tab ${editForm.type === "Flat" ? "active" : ""}`} onClick={() => ef("type", "Flat")}>₹ Flat</button>
                </div>
              </div>
              <div className="cp-field">
                <label className="cp-label">{editForm.type === "Percent" ? "Discount %" : "Discount ₹"}</label>
                <input className="cp-input" type="number" value={editForm.discount} onChange={e => ef("discount", e.target.value)} />
              </div>
              <div className="cp-field">
                <label className="cp-label">Min Order (₹)</label>
                <input className="cp-input" type="number" value={editForm.minOrder} onChange={e => ef("minOrder", e.target.value)} />
              </div>
              <div className="cp-field">
                <label className="cp-label">Max Uses</label>
                <input className="cp-input" type="number" value={editForm.maxUses === "9999" ? "" : editForm.maxUses} onChange={e => ef("maxUses", e.target.value)} placeholder="Unlimited" />
              </div>
              <div className="cp-field">
                <label className="cp-label">Expiry Date</label>
                <input className="cp-input" type="date" value={editForm.expiryDate} onChange={e => ef("expiryDate", e.target.value)} />
              </div>
              <div className="cp-field cp-full">
                <label className="cp-label">Status</label>
                <select className="cp-input" value={editForm.status} onChange={e => ef("status", e.target.value as "Active"|"Expired")}>
                  <option value="Active">Active</option>
                  <option value="Expired">Expired</option>
                </select>
              </div>
            </div>
            <div className="cp-modal-foot">
              <button className="cp-btn-cancel" onClick={() => setEditId(null)} type="button">Cancel</button>
              {/* <button className="cp-btn-save" onClick={saveEdit} type="button">Save Changes</button> */}
           <button
  className="cp-btn-save"
  onClick={updateCoupon}
  type="button"
>
  Save Changes
</button>
            </div>
          </div>
        </div>
      )}
      {/* ── Info / Success / Error Modal ── */}
{infoModal && (
  <div
    className="pm-del-overlay"
    onClick={() => setInfoModal(null)}
  >
    <div className="pm-del-box">

      <div
        className="pm-del-ico"
        style={{
          background:
            infoModal.type === "success"
              ? "#f0fdf4"
              : infoModal.type === "warn"
              ? "#fefce8"
              : "#fef2f2"
        }}
      >

        {/* SUCCESS */}
        {infoModal.type === "success" && (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#22c55e"
            strokeWidth="2.5"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        )}

        {/* WARNING */}
        {infoModal.type === "warn" && (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#eab308"
            strokeWidth="2.5"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        )}

        {/* ERROR */}
        {infoModal.type === "error" && (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ef4444"
            strokeWidth="2.5"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
        )}
      </div>

      <div
        className="pm-del-title"
        style={{
          color:
            infoModal.type === "success"
              ? "#166534"
              : infoModal.type === "warn"
              ? "#854d0e"
              : "#991b1b"
        }}
      >
        {infoModal.msg}
      </div>

      <div className="pm-del-btns">
        <button
          className="pm-btn-ghost"
          onClick={() => setInfoModal(null)}
          type="button"
        >
          OK
        </button>
      </div>

    </div>
  </div>
)}
    </>
  );
}
